"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const fmko_ts_common_1 = require("fmko-ts-common");
/**
 * @deprecated use {@link WCAGRadioGroup}
 */
class RadioGroup extends fmko_ts_common_1.Widget {
    constructor(radioButtons, wrapButtons = true) {
        super();
        this.radioButtons = radioButtons;
        this.handlerManager = new fmko_ts_common_1.HandlerManager();
        let selectedCount = 0;
        this.element = document.createElement("div");
        this.radioGroupId = fmko_ts_common_1.GlobalCounter.next();
        for (const button of radioButtons) {
            button.element.setAttribute("name", this.radioGroupId);
            if (button.getInput().checked) {
                this.setValue(button.getValue());
                selectedCount++;
            }
            button.addValueChangeHandler(value => {
                this.setValue(value.getValue(), true);
            });
            if (wrapButtons) {
                this.add(button.wrapButton(fmko_ts_common_1.GlobalCounter.next()));
            }
        }
        if (selectedCount > 1) {
            throw "More than one RadioButton are selected";
        }
    }
    getValue() {
        return this.value;
    }
    setValue(value, fireEvents) {
        if (fireEvents) {
            fmko_ts_common_1.ValueChangeEvent.fireIfNotEqual(this, this.value, value);
        }
        this.value = value;
    }
    getRadioButtons() {
        return this.radioButtons;
    }
    clearAndSetButtons(radioButtons, wrapButtons = true) {
        let selectedCount = 0;
        this.clearHTMLChildren();
        this.radioButtons = radioButtons;
        for (const button of radioButtons) {
            button.element.setAttribute("name", this.radioGroupId);
            if (button.getInput().checked) {
                this.setValue(button.getValue());
                selectedCount++;
            }
            button.addValueChangeHandler(value => {
                this.setValue(value.getValue(), true);
            });
            if (wrapButtons) {
                this.add(button.wrapButton(fmko_ts_common_1.GlobalCounter.next()));
            }
        }
        if (selectedCount > 1) {
            throw "More than one RadioButton are selected";
        }
    }
    // FUTURE WORK: ADD AND REMOVE RADIO BUTTONS
    addValueChangeHandler(handler) {
        return this.handlerManager.addHandler(handler);
    }
    fireEvent(event) {
        this.handlerManager.fireEvent(event);
    }
}
exports.default = RadioGroup;
//# sourceMappingURL=RadioGroup.js.map